import 'animate.css';
import { useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import angular from "../assets/img/angular.png";
import aseprite from "../assets/img/aseprite.png";
import blender from "../assets/img/blender.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import figma from "../assets/img/figma.png";
import git from "../assets/img/git.png";
import webtools from "../assets/img/webtools.png";
import sql from "../assets/img/sql.png";
import netbeans from "../assets/img/netbeans.png";
import projImg1 from "../assets/img/project-img1.png";
import projImg10 from "../assets/img/project-img10.png";
import projImg11 from "../assets/img/project-img11.png";
import projImg12 from "../assets/img/project-img12.png";
import projImg13 from "../assets/img/project-img13.png";
import projImg14 from "../assets/img/project-img14.png";
import projImg15 from "../assets/img/project-img15.png";
import projImg16 from "../assets/img/project-img16.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.png";
import projImg9 from "../assets/img/project-img9.png";
import react from "../assets/img/react.png";
import unity from "../assets/img/unity.png";
import { ProjectCard } from "./ProjectCard";

export const Projects = () => {
  const [activeTab, setActiveTab] = useState('first');

  const projects = [
    {
      title: "Music Blog HTML Bootstrap + Firebase",
      description: "Design & Development",
      imgUrl: projImg1,
      href: "https://demo-melomaniaviva.vercel.app/",
    },
    {
      title: "Crypto Dashboard API",
      description: "Design & Development",
      imgUrl: projImg2,
      href: "https://crypto-dashboard-bice.vercel.app/",
    },
    {
      title: "Sabujcha Landing Page",
      description: "Design & Development",
      imgUrl: projImg3,
      href: "https://sabujcha-jjk.netlify.app/",
    },
    {
      title: "NOUS CIMS Web",
      description: "Educamas Final Project",
      imgUrl: projImg4,
      href: "https://genero-front-six.vercel.app/",
    },
    {
      title: "Pokedex API",
      description: "Development",
      imgUrl: projImg5,
      href: "https://xpokedex-api.netlify.app/",
    },
    {
      title: "Inventory App JAVA",
      description: "Design & Development",
      imgUrl: projImg6,
      href: "https://github.com/karolgalindo02/kss_tech",
    },
  ];

  const projects1 = [
    {
      title: "Shooter PSX Style Unity 3D",
      description: "Level Design & Development",
      imgUrl: projImg16,
      href: "https://karolnwn.itch.io/mindfire-find-us",
    },
    {
      title: "WomanGameJame 'Time Loop' Unity",
      description: "PM, Pixel Artist & Development",
      imgUrl: projImg15,
      href: "https://karolnwn.itch.io/guayabo-eterno",
    },
    {
      title: "GameJame 'Floating Island' Unity",
      description: "PM, Level Design & Tech Artist",
      imgUrl: projImg14,
      href: "https://one-c.itch.io/deep-sky-island",
    },
    {
      title: "GameJame 'Grow' Unity",
      description: "PM, Game Design & Development of RPG Battle",
      imgUrl: projImg12,
      href: "https://karolnwn.itch.io/raise-dragons-and-go-to-sleep",
    },
    {
      title: "GameJame 'You're your enemy' Unity",
      description: "Level Design & Tech Artist",
      imgUrl: projImg7,
      href: "https://karolnwn.itch.io/fastasfood",
    },
    {
      title: "Prototype Unity 2D/3D",
      description: "Game Design & Development",
      imgUrl: projImg8,
      href: "https://karolnwn.itch.io/ghost-loves-candy",
    },
    {
      title: "Prototype Unity 3D",
      description: "Game Design & Development",
      imgUrl: projImg9,
      href: "https://karolnwn.itch.io/bunny-tower",
    },
    {
      title: "Prototype Unity 3D",
      description: "Game Design & Development",
      imgUrl: projImg10,
      href: "https://karolnwn.itch.io/skeleton-smasher",
    },
    {
      title: "Prototype Unity AR",
      description: "With Vuforia & Development",
      imgUrl: projImg13,
      href: "https://karolnwn.itch.io/arproject",
    },
  ];

  const others = [
    {
      title: "Vini Model Blender",
      description: "Modeling & Shading",
      imgUrl: projImg11,
      href: "https://www.artstation.com/karolgalindo02",
    },
  ];
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  useEffect(() => {
    console.log("Active tab changed to:", activeTab);
  }, [activeTab]);

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <h2>Projects</h2>
            <p>In the world of technology, I have developed video game prototypes and designed levels and assets for GameJams</p>
            <Tab.Container id="projects-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                <Nav.Item>
                  <Nav.Link eventKey="first">Web Pages</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Games</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Others</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content id="slideInUp">
                <Tab.Pane eventKey="first">
                  <Row>
                    {
                      projects.map((project, index) => {
                        return (
                          <ProjectCard
                            key={index}
                            {...project}
                          />
                        )
                      })
                    }
                  </Row>
                  <div className="skill-bx wow zoomIn">
                    <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                      <div className="item">
                        <img src={webtools} alt="Web Tools" />
                      </div>
                      <div className="item">
                        <img src={react} alt="React" />
                      </div>
                      <div className="item">
                        <img src={angular} alt="Angular" />
                      </div>
                      <div className="item">
                        <img src={sql} alt="SQL" />
                      </div>
                      <div className="item">
                        <img src={figma} alt="Figma" />
                      </div>
                      <div className="item">
                        <img src={git} alt="Git" />
                      </div>
                      <div className="item">
                        <img src={netbeans} alt="NetBeans" />
                      </div>
                    </Carousel>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    {
                      projects1.map((project, index) => {
                        return (
                          <ProjectCard
                            key={index}
                            {...project}
                          />
                        )
                      })
                    }
                  </Row>
                  <div className="skill-bx wow zoomIn">
                    <div className="skill-bx wow zoomIn">
                    <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                      <div className="item">
                        <img src={unity} alt="Unity" />
                      </div>
                      <div className="item">
                        <img src={git} alt="Git" />
                      </div>
                      <div className="item">
                        <img src={blender} alt="Blender" />
                      </div>
                      <div className="item">
                        <img src={aseprite} alt="Aseprite" />
                      </div>
                    </Carousel>
                  </div></div>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Row>
                    {
                      others.map((project, index) => {
                        return (
                          <ProjectCard
                            key={index}
                            {...project}
                          />
                        )
                      })
                    }
                  </Row>
                  <p>Upcoming projects in progress...</p>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="Background" />
    </section>
  )
}